import { observer } from 'mobx-react';
import { FC, useCallback, useEffect, useMemo } from 'react';
import { Prompt, StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { customersProfilesStore } from '../CustomersProfilesScreen/store';
import CustomerProfileEditStatusSwitcher from './components/CustomerProfileEditStatusSwitcher/CustomerProfileEditStatusSwitcher';
import CustomerProfileEditMain from './containers/CustomerProfileEditMain/CustomerProfileEditMain';
import CustomerProfileEditStatistics from './containers/CustomerProfileEditStatistics/CustomerProfileEditStatistics';
import CustomerProfileEditWallet from './containers/CustomerProfileEditWallet/CustomerProfileEditWallet';
import { customerProfileEditStore } from './store';
import { SCREENS } from 'src/constants/screens';
import { localeStore } from 'src/mobx/localesStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import { getPromptProps } from 'src/view/components/CustomPrompt/helper';
import LoadingOverlay from 'src/view/components/LoadingOverlay/LoadingOverlay';
import Headers from 'src/view/containers/Headers/Headers';
import HeaderBack from 'src/view/containers/Headers/components/HeaderBack/HeaderBack';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import { BUTTON_TITLE } from '~/constants/main';
import { getBackStepPath } from '~/helpers';
import { appStore } from '~/mobx/appStore';
import { Table } from '~/view/components/Table/Table';

type TProps = RouteComponentProps<{ id?: string }, StaticContext, undefined>;

const CustomerProfileEditScreen: FC<TProps> = observer((props: TProps): JSX.Element => {
  const backStepPath = useMemo((): string => getBackStepPath(SCREENS.CRM_PROFILES()), []);

  useEffect(() => {
    customerProfileEditStore.initStore();

    if (props.match.params.id) {
      customerProfileEditStore.setCustomer(customersProfilesStore.pagination.data.find((item) => item.id === Number(props.match.params.id)));
      if (!customerProfileEditStore.customer?.id) customerProfileEditStore.getCustomer(props.match.params.id);
      return;
    }

    customerProfileEditStore.setCustomer();
  }, []);

  const onSave = useCallback(() => {
    const { customer, setValidation, updateCustomer } = customerProfileEditStore;
    if (!customer) return;

    setValidation();

    if (customerProfileEditStore.validation.isValid) updateCustomer();
  }, []);

  return (
    <Table>
      <Headers>
        <HeaderBack title={customerProfileEditStore.customer?.name || ''} path={backStepPath} noTranslation />
      </Headers>
      <ScrollableBlock showScrollbar className="full-height mt-6">
        <CustomerProfileEditStatusSwitcher />
        <div className="d-flex flex-row flex-wrap gap-60">
          <CustomerProfileEditMain />
          <CustomerProfileEditStatistics />
          {appStore.isAddonsAvailable.wallet ? <CustomerProfileEditWallet /> : null}
        </div>
        <Button title={localeStore.t(BUTTON_TITLE.SAVE)} onClick={onSave} loading={customerProfileEditStore.loading} className="mt-8" />
      </ScrollableBlock>
      <LoadingOverlay visible={customerProfileEditStore.loading} />
      <Prompt when={customerProfileEditStore.edited} message={getPromptProps()} />
    </Table>
  );
});

export default CustomerProfileEditScreen;
